import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Icon } from '@flowio/react-icon';
import React from 'react';

var ToastIcon = function ToastIcon(props) {
  var rootStyles = function rootStyles(theme) {
    return /*#__PURE__*/css({
      flex: '0 0 auto',
      width: 'auto',
      height: '24px',
      marginRight: theme.direction === 'ltr' ? '1rem' : undefined,
      marginLeft: theme.direction === 'rtl' ? '1rem' : undefined,
      marginInlineEnd: '1rem'
    }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RvYXN0SWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBY3lEIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RvYXN0SWNvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cblxuaW1wb3J0IHtcbiAgY3NzLCBqc3gsIFNlcmlhbGl6ZWRTdHlsZXMsIFRoZW1lLFxufSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBJY29uIH0gZnJvbSAnQGZsb3dpby9yZWFjdC1pY29uJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbnR5cGUgUHJvcHMgPSBKU1guTGlicmFyeU1hbmFnZWRBdHRyaWJ1dGVzPFxuICB0eXBlb2YgSWNvbixcbiAgUmVhY3QuQ29tcG9uZW50UHJvcHM8dHlwZW9mIEljb24+XG4+O1xuXG5jb25zdCBUb2FzdEljb246IFJlYWN0LkZDPFByb3BzPiA9IChwcm9wcykgPT4ge1xuICBjb25zdCByb290U3R5bGVzID0gKHRoZW1lOiBUaGVtZSk6IFNlcmlhbGl6ZWRTdHlsZXMgPT4gY3NzKHtcbiAgICBmbGV4OiAnMCAwIGF1dG8nLFxuICAgIHdpZHRoOiAnYXV0bycsXG4gICAgaGVpZ2h0OiAnMjRweCcsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLmRpcmVjdGlvbiA9PT0gJ2x0cicgPyAnMXJlbScgOiB1bmRlZmluZWQsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuZGlyZWN0aW9uID09PSAncnRsJyA/ICcxcmVtJyA6IHVuZGVmaW5lZCxcbiAgICBtYXJnaW5JbmxpbmVFbmQ6ICcxcmVtJyxcbiAgfSk7XG4gIHJldHVybiAoXG4gICAgPEljb24gey4uLnByb3BzfSBjc3M9e3Jvb3RTdHlsZXN9IC8+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBUb2FzdEljb247XG4iXX0= */");
  };

  return jsx(Icon, _extends({}, props, {
    css: rootStyles
  }));
};

export default ToastIcon;